$(document).ready(function(){

    // MAIN NAVS
    $('.full-menu-btn').click(function(){
        $('.fullscreen-nav').toggleClass('open');
        $('.content-website').toggleClass('open-menu');
        $('.overlay-website').toggleClass('actif');
        $(this).toggleClass('close-btn'); 
    })
   
    $('.partner-menu-btn').click(function(){
        $('.fullscreen-partner-nav').toggleClass('open');
        $('.content-website').toggleClass('open-menu');
        $('.overlay-website').toggleClass('actif');
        $('.close').addClass('close-btn'); 
    })
    $('.close').click(function(){
        $('.fullscreen-partner-nav').removeClass('open');
        $('.content-website').removeClass('open-menu');
        $('.overlay-website').removeClass('actif');
        $('.close').removeClass('close-btn'); 
    })

    // Init Wow
    wow = new WOW({
          animateClass: 'animated',
          offset: 100
        });
    wow.init();

    // bootstrap accordion
    function toggleIcon(e) {
        $(e.target)
            .prev('.panel-heading')
            .find(".short-full")
            .toggleClass('glyphicon-plus glyphicon-minus');
    }
    $('.panel-group').on('hidden.bs.collapse', toggleIcon);
    $('.panel-group').on('shown.bs.collapse', toggleIcon);

});  
